import Helpers from '../../../common/helpers/Helpers';
import Constants from '../../../common/constants/Constants';

export const getUserAuditLogsData = (dateFrom, dateTo) => {
  let query = {
    dateFrom: dateFrom,
    dateTo: dateTo
  };

  return Helpers.get(`${Constants.USER_AUDIT_LOGS_URL}`, {}, query);
};

export const getRoles = () => {
  return Helpers.get(Constants.ROLES_URL);
};
